/* eslint-disable prettier/prettier */

import { Util } from "./utils/util";

export class PgSql {
    getSelectQuery(tableName: string, limit: number = 0): string {
        let query = `SELECT * FROM ${tableName} LIMIT ${limit || 1000};`;
        return query;
    }

    getInsertQuery(tableName: string, columns: string[], values: string[][]): string {
        let pre = `SET IDENTITY_INSERT [${tableName}] ON; `;
        let queries = values.map((row: string[]) => {
            let rowData = row.map((value) => this.parse(value));
            return `INSERT INTO [${tableName}] ([${columns.join("], [")}]) VALUES (${rowData.join(", ")});`;
        });
        let query = queries.join("\n");
        // var query = `INSERT INTO [${tableName}] ([${columns.join("], [")}]) VALUES (${values.join(", ")})`;
        let post = `SET IDENTITY_INSERT [${tableName}] OFF;`;

        return `${pre} \n\n${query} \n\n${post}`;
    }

    getUpdateQuery(tableName: string, columns: string[], values: string[][], startCol: number, endCol: number): string {
        let queries = values.map((row: string[]) => {
            let rowData = row.slice(startCol, endCol).map((value, index) => `${columns[startCol + index]} = ${this.parse(value)}`);
            return `UPDATE ${tableName} SET ${rowData.join(", ")} where ${columns[0]} = ${row[0]};`;
        });
        let query = queries.join("\n");

        return query;
    }

    getAddColumnQuery(tableName: string, columns: string[], values: string[][], startCol: number, endCol: number): string {
        let queries = columns.slice(startCol, endCol).map((column) => {
            column = Util.underscoreCase(column);
            return `ALTER TABLE [${tableName}] ADD [${column}] ${this.getDataType(column, values)};`;
        });
        let query = queries.join("\n");
        return query;
    }

    getRenameColumnQuery(tableName: string, columns: string[], startCol: number, endCol: number): string {
        let queries = columns.slice(startCol, endCol).map((column) => {
            return `EXEC sp_rename '${tableName}.[${column}]', '${column}_new', 'COLUMN';`;
        });
        let query = queries.join("\n");

        return query;
    }

    // Generate query to create a table in PostgreSQL
    getCreateQuery(tableName: string, columns: string[], values: string[][]): string {
        tableName = Util.underscoreCase(tableName);
        let queries = columns.map((column) => {
            column = Util.underscoreCase(column);
            return `[${column}] ${this.getDataType(column, values)}`;
        });
        let query = `CREATE TABLE [${tableName}] (\n\t${queries.join(", \n\t")}\n);`;

        return query;
    }

    getDataType(columnName: string, values: string[][]): string {
        columnName = Util.underscoreCase(columnName);
        let dataType = "VARCHAR(250)";
        let maxLength = 0;
        values.forEach((value) => {
            if (value !== null && value.length > maxLength) {
                maxLength = value.length;
            }
        });

        maxLength = Math.max(maxLength, 20);
        if (maxLength > 20) {
            maxLength = Math.max(maxLength, 50);
        }
        if (maxLength > 50) {
            maxLength = Math.max(maxLength, 250);
        }

        let map = {
            id: "SERIAL PRIMARY KEY",
            uuid: "UUID NOT NULL DEFAULT uuid_v7()",
            is_active: "BOOLEAN NOT NULL DEFAULT TRUE",
            create_date: "TIMESTAMP DEFAULT CURRENT_TIMESTAMP",
            update_date: "TIMESTAMP",
            created_by: "INTEGER NOT NULL",
            updated_by: "INTEGER NULL",
            ip_address: "VARCHAR(50)",
        };

        if (map[columnName]) {
            return map[columnName];
        }

        if (columnName == 'id') {
            dataType = "SERIAL PRIMARY KEY NOT NULL";
        } else if (columnName.endsWith("url") || columnName.endsWith("website")) {
            dataType = "VARCHAR(500)";
        } else if (columnName.endsWith("name")) {
            dataType = "VARCHAR(50)";
        } else if (columnName.endsWith("email")) {
            dataType = "VARCHAR(150)";
        } else if (columnName.endsWith("_id") || columnName.endsWith("count") || columnName.endsWith("_number") || columnName.includes("_total")) {
            dataType = "INT";
        } else if (columnName.startsWith("is_") || columnName.startsWith("has_")) {
            dataType = "BOOLEAN";
        } else if (columnName.endsWith("_date") || columnName.endsWith("_time")) {
            dataType = "TIMESTAMP";
        } else if (maxLength > 0) {
            dataType = `VARCHAR(${maxLength})`;
        }

        return dataType;
    }

    parse(value: any) {
        if (value === null || value === '') {
            return "NULL";
        }
        return this.needQuotes(value) ? `N'${value.replace("'", "''")}'` : value;
    }

    needQuotes(value: any) {
        return !this.isNumeric(value) && !this.isSqlFunction(value);
    }

    isNumeric(value: any) {
        return !isNaN(value);
    }

    isSqlFunction(value: string) {
        let funcs = ['GETDATE()', 'GETUTCDATE()', 'NEWID()', 'CURRENT_TIMESTAMP', 'CURRENT_USER', 'SESSION_USER', 'SYSTEM_USER', 'USER_NAME()', 'HOST_NAME()'];
        return funcs.includes(value.toUpperCase());
    }
}